<template>
  <v-layout class="top-global-search" v-resize="onResize">
    <v-flex xl6 lg6 md12 sm12 xs12>
      <v-menu v-model="menu" offset-y :close-on-click="open" :close-on-content-click="close" :min-width="(isMobile) ? responsiveWidth : 850" fixed :nudge-top="(isMobile) ? 5 : 8" :nudge-left="(isMobile) ? 0 : 0" attach="#appContent">
          <v-text-field class="c-text" @blur="open=true;close=false" @focus="open=false;close=false" slot="activator" v-model="searchValue" placeholder="Search" hide-details :solo-inverted="(isMobile) ? false : true" :solo="(isMobile) ? true : false" :flat="(isMobile) ? false : true" clearable>
        </v-text-field>
        <v-card>
          <v-card class="pa-1">
            <div class="d-inline">
              <v-btn flat :class="(isAll) ? `primary white--text` : ``" @click.stop="all" class="ma-0">All</v-btn>
              <v-btn flat :class="(isCustomer) ? `primary white--text` : ``" @click.stop="customer" class="ma-0">Customer</v-btn>
              <v-btn flat :class="(isLead) ? `primary white--text` : ``" @click.stop="lead" class="ma-0">Lead</v-btn>
            </div>
            <p :class="(isMobile) ? `mt-2 d-inline-block` : `ml-3 d-inline`" class="mb-0 info--text c-pointer" @click.stop="$store.dispatch('SetFullScreenAdvanceSerach', {status: true, advanceSearchValue: searchValue})">Advanced search</p>
          </v-card>
          <p v-if="minLengthAll" class="mt-3 mx-1 mb-0 subheading">
            <span class="font-weight-medium mr-1">Note:</span>
            <span v-text="'Please enter 3 characters or more.'"></span>
          </p>
          <p class="mt-3 mx-1 mb-0 subheading" v-text="'No record(s) found...'" v-if="(allData.length === 0 && !allLoading && !minLengthAll) && showNoallData"></p>
          <v-list class="custom-list" :style="`max-height:` + maxHeight + `px`" :id="containerId">
            <template v-for="(item, index) in allData">
              <v-list-tile-content :key="index" :id="`list-index`+index">
                <v-list-tile-sub-title>
                  <div @click="reset(item);close=true;open=true;menu=false" class="pa-1 c-pointer">
                    <a class="subheading pb-0" v-html="matchFind(item.companyName)"></a>
                    <span :class="(item.isLead) ? `green--text` : `primary--text`">{{(item.isLead) ? ' (Lead)' : ' (Customer)'}}</span>
                    <div class="ml-3">
                      <v-layout row wrap v-for="(contact, index) in item.contactList" :key="index+'i'">
                        <v-icon size="15">contacts</v-icon>
                        <span class="body-1 mr-2 ml-1 font-weight-bold" v-html="matchFind(contact.Fname + ' ' + contact.Lname + ' ')"></span>
                        <v-icon size="15" v-if="contact.email.length > 0" class="mr-0">email</v-icon>
                        <div v-for="(email, index) in contact.email" :key="index+'e'">
                          <span class="body-1" v-html="matchFind(email)"></span>
                        </div>
                        <v-icon size="15" v-if="contact.number.length > 0" class="ml-1">phone</v-icon>
                        <div v-for="(number, index) in contact.number" :key="index+'n'">
                          <span class="body-1 mr-1" v-html="matchFind(number)"></span>
                        </div>
                      </v-layout>
                      <div v-for="(address, index) in item.addressList" :key="index+'a'">
                        <v-icon size="15">location_on</v-icon>
                        <span class="body-1" v-html="matchFind(address)" style="word-break: break-all;white-space: pre-line;"></span>
                      </div>
                    </div>
                  </div>
                  <v-divider v-if="index !== allData.length" class="mx-1"></v-divider>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
            <template v-if="noMoreData && !showNoallData && !minLengthAll">
              <v-list-tile-content>
                <v-list-tile-sub-title>
                <p class="mx-1 pt-1 pb-0 mb-0">{{noMoreMsg}}</p>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
            <template v-else>
              <v-list-tile-content v-if="isMobile &&  !showNoallData && !minLengthAll && !allLoading">
                <v-list-tile-sub-title>
                <a class="mt-2 mx-1 mb-0" @click.stop="handleScroll">Load more</a>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-list>
           <v-layout v-if="allLoading" class="pa-2">
            <v-flex class="text-xs-center">
              <v-progress-circular :indeterminate="allLoading" size="20" :width="2" color="info"></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-card>
      </v-menu>
    </v-flex>
  </v-layout>
</template>
<script>
import Crm from '@/api/Crm'
var delay = (function () {
  var timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      isMobile: false,
      maxHeight: 800,
      allLoading: false,
      isAll: true,
      isLead: false,
      isCustomer: false,
      searchWith: '',
      sameEntity: '',
      objArr: [],
      allItems: [],
      open: true,
      close: true,
      showallData: false,
      showNoallData: false,
      minLengthAll: true,
      searchValue: null,
      selectAll: null,
      allData: [],
      descriptionLimit: 60,
      isLeadSearch: false,
      isAllSearch: true,
      repeatVal: '',
      menu: false,
      containerId: 'loadMore',
      start: 0,
      length: 25,
      x: 0,
      y: 0,
      noMoreData: false,
      noMoreMsg: '',
      responsiveWidth: 350
    }
  },
  mounted () {
    this.maxHeight = window.innerHeight - 200
    this.onResize()
    // document.getElementById(this.containerId).addEventListener('scroll', this.handleScroll)
    // console.log('scrolling Injected')
  },
  beforeDestroy () {
    document.getElementById(this.containerId).removeEventListener('scroll', this.handleScroll)
    // console.log('scrolling Destroyed')
  },
  watch: {
    searchValue: {
      handler (val) {
        // console.log('search', val)
        // console.log('sameEntity', this.sameEntity)
        if (this.noMoreData) {
          this.start = 0
          this.length = 25
        }
        // console.log(this.searchValue)
        this.searchValueCheck()
      }
    },
    deep: true
  },
  methods: {
    onResize () {
      if (window.innerWidth <= 1264) {
        this.isMobile = true
        this.responsiveWidth = window.innerWidth - 15
        this.maxHeight = window.innerHeight - 100
      } else {
        this.isMobile = false
      }
    },
    handleScroll () {
      if (this.noMoreData) {
        return
      }
      if (this.isMobile) {
        this.allLoading = true
        this.start = this.start + 25
        this.length = this.length + 25
        this.searchValueCheck('more')
        return
      }
      this.scrolled = window.scrollY > 0
      var sh = document.getElementById(this.containerId).scrollHeight
      var st = document.getElementById(this.containerId).scrollTop
      var oh = document.getElementById(this.containerId).offsetHeight
      // console.log('scrolling..' + (sh - st - oh + 1))
      if (sh - st - oh + 1 === 1) {
        this.allLoading = true
        this.start = this.start + 25
        this.length = this.length + 25
        this.searchValueCheck('more')
        // var n = this.items.length+1
        // this.items.push({value: n, description: "New loaded content #:"+n})
      }
    },
    all () {
      if (this.searchValue === this.repeatVal) {
        if (this.sameEntity === 'all') {
          return
        }
      }
      this.isAll = true
      this.isCustomer = false
      this.isLead = false
      this.showNoallData = false
      this.start = 0
      this.length = 25
      this.allData = []
      this.noMoreData = false
      this.noMoreMsg = ''
      if (this.isMobile) {
        document.getElementById(this.containerId).removeEventListener('touchmove', this.handleScroll)
      } else {
        document.getElementById(this.containerId).removeEventListener('scroll', this.handleScroll)
      }
      // document.getElementById(this.containerId).addEventListener('scroll', this.handleScroll)
      this.searchValueCheck()
    },
    customer () {
      if (this.searchValue === this.repeatVal) {
        if (this.sameEntity === 'company') {
          return
        }
      }
      this.isAll = false
      this.isCustomer = true
      this.isLead = false
      this.showNoallData = false
      this.start = 0
      this.length = 25
      this.allData = []
      this.noMoreData = false
      this.noMoreMsg = ''
      document.getElementById(this.containerId).removeEventListener('scroll', this.handleScroll)
      // document.getElementById(this.containerId).addEventListener('scroll', this.handleScroll)
      this.searchValueCheck()
    },
    lead () {
      if (this.searchValue === this.repeatVal) {
        if (this.sameEntity === 'lead') {
          return
        }
      }
      this.isAll = false
      this.isCustomer = false
      this.isLead = true
      this.showNoallData = false
      this.start = 0
      this.length = 25
      this.allData = []
      this.noMoreData = false
      this.noMoreMsg = ''
      document.getElementById(this.containerId).removeEventListener('scroll', this.handleScroll)
      // document.getElementById(this.containerId).addEventListener('scroll', this.handleScroll)
      this.searchValueCheck()
    },
    matchFind (str) {
      if (str === null || str === undefined || str === ' ') {
        return
      }
      var serachValue = this.searchValueDefine()
      let searchStrArray = serachValue.split(' ')
      // console.log('=====================================================', searchStrArray.length)
      let replceString = str.trim()
      for (let i = 0; i < searchStrArray.length; i++) {
        if (searchStrArray[i].trim() !== '') {
          replceString = replceString.replace(new RegExp(searchStrArray[i], 'gi'), match => {
            return '<span class="highlightText">' + match + '</span>'
          })
        }
      }
      return replceString
    },
    searchValueCheck (type) {
      let val = this.searchValue
      if (val === '' || val === null || val === undefined) {
        this.minLengthAll = true
        this.repeatVal = ''
        this.searchValue = ''
        this.start = 0
        this.length = 25
        this.allData = []
        this.allLoading = false
        this.showNoallData = false
        this.noMoreData = false
        this.noMoreMsg = ''
        this.sameEntity = ''
        return
      }
      if (val === '' || val === null || val === undefined) {
        this.allData = []
        this.noMoreData = false
        this.noMoreMsg = ''
      } else if (val !== '' && val !== null && val !== undefined) {
        if (val.length > 2) {
          this.minLengthAll = false
          this.allLoading = true
          if (type !== 'more') {
            this.allData = []
            this.noMoreData = false
            this.noMoreMsg = ''
          }
          this.searchValue = val
          if (this.isAll) {
            this.isLeadSearch = false
            this.isAllSearch = true
          } else if (this.isCustomer) {
            this.isLeadSearch = false
            this.isAllSearch = false
          } else if (this.isLead) {
            this.isLeadSearch = true
            this.isAllSearch = false
          }
          let self = this
          delay(function () {
            if (val !== '' && val !== null && val !== undefined) {
              self.callSearchApi(type)
            }
          }, 300)
        }
      }
    },
    searchValueDefine () {
      // manipulate search value string for match and api call
      var serachValue = ''
      var serachNumber = []
      var operateValue = this.searchValue.replace(/-|\(|\)/g, ' ')
      let searchStrArray = operateValue.split(' ')
      for (let i = 0; i < searchStrArray.length; i++) {
        if (searchStrArray[i].trim() !== '') {
          if (searchStrArray[i].search('@') === -1) {
            var serachNumberTest = searchStrArray[i].replace(/-|\(|\)|\./g, '')
            console.log('test', isNaN(serachNumberTest), serachNumberTest)
            if (isNaN(serachNumberTest) === false) {
              serachNumber.push(serachNumberTest)
            } else {
              serachValue += searchStrArray[i] + ' '
            }
          } else {
            serachValue += searchStrArray[i] + ' '
          }
        }
        if (serachNumber.length > 0 && serachNumber.length === 3) {
          if (serachNumber[0].length === 3 && serachNumber[1].length === 3 && serachNumber[2].length === 4) {
            var numberStr = serachNumber.join('')
            serachValue += numberStr + ' '
            serachNumber = []
          } else {
            for (let i = 0; i < serachNumber.length; i++) {
              serachValue += serachNumber[i] + ' '
            }
            serachNumber = []
          }
        }
      }
      if (serachNumber.length > 0) {
        for (let i = 0; i < serachNumber.length; i++) {
          serachValue += serachNumber[i] + ' '
        }
        serachNumber = []
      }
      console.log('call 1')
      return serachValue
    },
    callSearchApi (type) {
      let searchVal = this.searchValueDefine()
      this.loadAsyncData(type, searchVal)
    },
    loadAsyncData (type, value) {
      if (this.searchValue !== '' && this.searchValue !== null && this.searchValue !== undefined) {
        // let searchVal = this.searchValue.replace(/[(]/g, '').replace(/[)]/g, '').replace(/[-]/g, ' ')
        Crm.globalSearch(
          value,
          this.isLeadSearch,
          this.isAllSearch,
          this.start,
          this.length,
          response => {
            if (type !== 'more') {
              this.objArr = []
              if (response.Data.length < 25 && response.Data.length > 0) {
                this.noMoreData = true
                this.noMoreMsg = 'No more record(s)'
                this.showNoallData = false
              } else {
                document.getElementById(this.containerId).addEventListener('scroll', this.handleScroll)
              }
            }
            if (this.searchValue === '') {
              return
            }
            this.repeatVal = this.searchValue
            if (this.isAllSearch) {
              this.searchWith = 'all'
            } else {
              if (this.isLeadSearch) {
                this.searchWith = 'lead'
              } else {
                this.searchWith = 'company'
              }
            }
            this.sameEntity = this.searchWith
            if (response.Data.length > 0) {
              let tempArr = response.Data
              for (let c = 0; c < tempArr.length; c++) {
                let customer = tempArr[c]
                customer.fullSearch = customer.companyName
                let obj = {
                  companyId: customer.companyId,
                  leadId: customer.leadId,
                  companyName: customer.companyName,
                  contactList: [],
                  addressList: [],
                  isLead: customer.isLead,
                  fullSearch: '',
                  index: null
                }
                let address = JSON.parse(customer.addressList)
                if (address.AddList !== null) {
                  for (let a = 0; a < address.AddList.length; a++) {
                    let trempAddress = address.AddList[a]
                    trempAddress = trempAddress.split('::')[1]
                    trempAddress = trempAddress.replace('( - )', '')
                    trempAddress = trempAddress.replace(' - )', ')')
                    var distanceSubString = trempAddress.substring(
                      trempAddress.lastIndexOf('(') + 1,
                      trempAddress.lastIndexOf('-')
                    )
                    // console.log('distanceSubString', distanceSubString)
                    trempAddress = trempAddress.replace(distanceSubString, this.$options.filters.distanceUnit(distanceSubString) + ' ')
                    customer.fullSearch += ' ' + trempAddress
                    obj.addressList.push(trempAddress)
                  }
                }
                let contactList = JSON.parse(customer.contactList)
                for (let n = 0; n < contactList.ContactData.length; n++) {
                  let contact = contactList.ContactData[n]
                  let tempContact = {
                    Fname: contact.Fname,
                    Lname: contact.Lname,
                    number: [],
                    email: []
                  }
                  customer.fullSearch += ' ' + contact.Fname + ' ' + contact.Lname
                  if (contact.Email !== null) {
                    for (let e = 0; e < contact.Email.length; e++) {
                      let email = contact.Email[e]
                      customer.fullSearch += ' ' + email
                      tempContact.email.push(email)
                    }
                  }
                  if (contact.AllNumber !== null) {
                    for (let p = 0; p < contact.AllNumber.length; p++) {
                      let number = contact.AllNumber[p]
                      customer.fullSearch += ' ' + number
                      number = number.replace('::', ':').trim()
                      number += (p !== contact.AllNumber.length - 1) ? ', ' : ''
                      tempContact.number.push(number)
                    }
                  }
                  obj.contactList.push(tempContact)
                }
                obj.fullSearch = customer.fullSearch
                obj.index = c
                this.objArr.push(obj)
              }
              this.showallData = true
              if (type !== 'more') {
                this.allData = []
                if (response.Data.length >= 25) {
                  this.noMoreData = false
                  this.noMoreMsg = ''
                }
              }
              this.allData = this.objArr
              this.allLoading = false
            } else {
              if (type !== 'more') {
                this.allData = []
                this.noMoreData = false
                this.noMoreMsg = ''
                this.showNoallData = true
              } else {
                this.noMoreData = true
                this.noMoreMsg = 'No more record(s)'
              }
              this.showallData = false
              this.allLoading = false
            }
          },
          error => {
            this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
            this.allLoading = false
          }
        )
      }
    },
    show (e) {
      e.preventDefault()
      this.menu = true
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.menu = true
      })
    },
    reset (item) {
      this.allData = []
      this.noMoreData = false
      this.noMoreMsg = ''
      this.searchValue = ''
      this.start = 0
      this.length = 25
      this.showallData = false
      this.showNoallData = false
      if (item.isLead === true) {
        this.$router.push({name: 'leadDetail', params: {leadid: item.leadId}})
      } else {
        this.$router.push({name: 'companyDetail', params: {companyId: item.companyId}})
      }
      this.isAll = true
      this.isLead = false
      this.isCustomer = false
      this.sameEntity = ''
    },
    doNotChange () {
    }
  }
}
</script>
<style scoped>
.v-btn{
  text-transform: none!important;
}
.main{
  border: 1px solid black;
  cursor: pointer;
  border-radius: 5px;
}
.all{
  display: inline-block;
  border: 1px;
}
.customer{
  display: inline-block;
}
.lead{
  display: inline-block;
    border: 1px;
}
.custom-list{
  overflow: auto;
}
.v-menu__activator{
  cursor: unset!important;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/layout/components/globalSearch.vue